export default {
    CHANGE_PAGE_REQUEST: 'CHANGE_PAGE_REQUEST',
    COLLAPSE_NAV_REQUEST: 'COLLAPSE_NAV_REQUEST',
    NAV_SIZE_CHANGE: 'NAV_SIZE_CHANGE',
};
